/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { useRef, useEffect } from 'react';

function useDialogPosition(visible, dialogCardRef) {
  var mousePosRef = useRef(null);
  var getClickPosition = function getClickPosition(e) {
    mousePosRef.current = {
      x: e.clientX,
      y: e.clientY
    };
    setTimeout(function () {
      mousePosRef.current = null;
    }, 100);
  };
  if (typeof document !== "undefined") {
    document.addEventListener("click", getClickPosition, true);
  }
  useEffect(function () {
    document.addEventListener("click", getClickPosition, true);
    return function () {
      document.removeEventListener("click", getClickPosition, true);
    };
  }, []);
  useEffect(function () {
    if (!visible) return;
    if (mousePosRef.current && dialogCardRef.current) {
      dialogCardRef.current.style.transformOrigin = "".concat(mousePosRef.current.x - dialogCardRef.current.offsetLeft, "px ").concat(mousePosRef.current.y - dialogCardRef.current.offsetTop, "px");
    }
  }, [visible, dialogCardRef]);
}

export { useDialogPosition as default };
//# sourceMappingURL=useDialogPosition.js.map
